import { Box, Typography } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const DocumentCard = ({ title, onDownload }) => {
  // Indian Government Colors
  const govtColors = {
    saffron: '#FF9933',
    green: '#138808',
    navy: '#0B2A4A',
    // blue: '#1E3A8A',
    primary: '#1E3A8A'
  };

  return (
    <Box
      onClick={onDownload}
      sx={{
        width: "100%",
        height: { xs: 76, sm: 72 },
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 2,
        borderRadius: 2,
        backgroundColor: "#ffffff",
        border: "1px solid",
        borderColor: `${govtColors.navy}20`,
        borderLeft: "6px solid",
        borderLeftColor: govtColors.primary,
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: "0 2px 6px rgba(0,0,0,0.03)",
        position: 'relative',
        overflow: "hidden",
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          right: 0,
          width: '40px',
          height: '40px',
          background: `linear-gradient(135deg, transparent 50%, ${govtColors.green}08 50%)`,
        },
        "&:hover": {
          borderColor: govtColors.navy,
          boxShadow: `0 6px 16px ${govtColors.primary}20`,
          '& .view-text': {
            color: govtColors.green,
          },
        },
      }}
    >
      {/* Icon with Tricolor Accent */}
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "12px",
          background: `linear-gradient(135deg, ${govtColors.primary}20, ${govtColors.green}20)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          border: `1px solid ${govtColors.navy}30`,
        }}
      >
        <DescriptionOutlinedIcon
          sx={{ color: govtColors.navy, fontSize: 22 }}
        />
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "0.95rem",
            color: govtColors.navy,
            lineHeight: 1.3,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            mb: 0.3,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "0.7rem",
            color: "#666",
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Box component="span" sx={{ color: govtColors.primary }}>◆</Box>
          Official Document
        </Typography>
      </Box>

      {/* Right Action */}
      <Typography
        className="view-text"
        sx={{
          fontSize: "0.8rem",
          fontWeight: 700,
          color: govtColors.blue,
          flexShrink: 0,
          letterSpacing: '0.5px',
          transition: 'color 0.2s ease',
        }}
      >
        OPEN
      </Typography>
    </Box>
  );
};

export default DocumentCard;





// import { Box, Typography } from "@mui/material";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import AppButton from "../AppButton/AppButton";

// const DocumentCard = ({ title, description, onDownload }) => {
//   return (
//     <Box
//       sx={{
//         border: "1px solid #e0e0e0",
//         borderRadius: 3,
//         p: 3,
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       <DescriptionOutlinedIcon
//         sx={{ color: "#1e5bff", fontSize: 36, mb: 2 }}
//       />

//       <Typography fontWeight={600} mb={1}>
//         {title}
//       </Typography>

//       <Typography color="text.secondary" sx={{ flexGrow: 1 }}>
//         {description}
//       </Typography>

//       <AppButton
//         label="Preview Document"
//         variant="outlined"
//         fullWidth
//         // sx={{ mt: 0.5 }}
//         onClick={onDownload}
//       />
//     </Box>
//   );
// };

// export default DocumentCard;
